import React, { useContext } from 'react';

import { CuiIntegrationsConnection } from '../../../../connection-components/integrations-connection';
import { enums } from '../constants';
import { IntegrationsContext } from '../context';
import style from '../style.module.less';
import QuickbooksSetting from './settings';

export const Quickbooks = () => {
  const { integrations } = useContext(IntegrationsContext);
  if (!integrations) {
    return null;
  }

  const QuickBooksAppId = enums.quickbooks;

  const quickbooksIntegrations = integrations.find((i) => parseInt(i.integratedAppID, 10) === QuickBooksAppId);

  if (quickbooksIntegrations?.count > 0) {
    return <QuickbooksSetting />;
  }

  return (
    <div className={style['cui-container']}>
      <CuiIntegrationsConnection integrationAppId={QuickBooksAppId} />
    </div>
  );
};
